<div class="header" fxLayout="column">
    <div fxLayout="row" style="margin: 10px;" fxLayoutAlign="space-between start">
        <div *ngIf="titleIcon">
            <mat-icon style="font-size: 20px;">
              {{titleIcon}}</mat-icon>
        </div>
        <div style="display: flex; flex-direction: row; align-items: normal;" class="title" [ngStyle]="{'width': titleIcon ? '100%' : '60%'}">
          <strong style="color: #085edb; font-size: 16px; font-weight: bolder; margin-right: 4px;" *ngIf="prefix">{{prefix}} </strong><strong>{{title}}</strong>

            <!-- only for leads modules -->
            <div *ngIf="showLeadsError" style="display: flex; margin-left: 10px;">
                <mat-icon style="font-size: 20px; color: red">info</mat-icon>
                <div style="color: red; background: #ff00002b; padding-left: 5px; padding-right: 5px; align-self: baseline">
                    This lead belongs to an open territory
                </div>
            </div>

            </div>
            <div fxLayout="row" fxLayoutGap="10px">
            <div class="creation-date" *ngIf="showCreationDate">
                <strong>
                    Creation Date & Time: {{createdDate ? formatDate(createdDate): formatDate()}}
                </strong>
            </div>
            <div *ngIf="canMaximize">
                <i class="fas pointer"
                (click)="toggleSize()"
                [ngClass]="{'fa-expand-alt': !isMaximized, 'fa-compress-alt': isMaximized}"
                [title]="isMaximized ? 'Exit Full Screen' : 'Enter Full Screen'"></i>
           </div>
            <div>
                <i class="fas fa-times pointer" (click)="close()" title="Close Popup"></i>
            </div>
        </div>
    </div>
    <mat-divider></mat-divider>
</div>
